import React, { Component } from "react"
import { Link } from "gatsby"
// import AnchorLink from 'react-anchor-link-smooth-scroll';

import Layout from "../components/layout"
import SEO from "../components/seo"

import SimpleModal from "../components/utilities/SimpleModal"

import "./casestudycobrcentennial.scss"

import imgQuote from "../images/quotation_mark.webp"

class VideoLauncher extends Component {
  constructor(props) {
    super(props)
    this.modalRef = React.createRef()
    this.openModal = this.openModal.bind(this)
  }
  openModal() {
    this.modalRef.current.handleOpen()
  }

  render() {
    return (
      <div
        onClick={() => this.openModal()}
        id="videoLauncher"
        className="videoLauncherBtn"
      >
        <img
          src="https://www.meritmile.com/uploads/2026/02/video-launcher-1.webp"
          className="results-image img-fluid"
          alt="Boca100 Video 1"
          width="616px"
        />
        <SimpleModal videoSRC="YV_sMfdArAM" innerRef={this.modalRef} />
      </div>
    )
  }
}

class VideoLauncherTwo extends Component {
  constructor(props) {
    super(props)
    this.modalRef = React.createRef()
    this.openModal = this.openModal.bind(this)
  }
  openModal() {
    this.modalRef.current.handleOpen()
  }

  render() {
    return (
      <div
        onClick={() => this.openModal()}
        id="videoLauncher"
        className="videoLauncherBtn"
      >
        <img
          src="https://www.meritmile.com/uploads/2026/02/video-launcher-2.webp"
          className="results-image img-fluid"
          alt="Boca100 Video 2"
          width="616px"
        />
        <SimpleModal videoSRC="bUcZIkdJDHU" innerRef={this.modalRef} />
      </div>
    )
  }
}

class VideoLauncherThree extends Component {
  constructor(props) {
    super(props)
    this.modalRef = React.createRef()
    this.openModal = this.openModal.bind(this)
  }
  openModal() {
    this.modalRef.current.handleOpen()
  }

  render() {
    return (
      <div
        onClick={() => this.openModal()}
        id="videoLauncher"
        className="videoLauncherBtn"
      >
        <img
          src="https://www.meritmile.com/uploads/2026/02/video-launcher-3.webp"
          className="results-image img-fluid"
          alt="Boca100 Video 3"
          width="616px"
        />
        <SimpleModal videoSRC="TeSc9fciT6c" innerRef={this.modalRef} />
      </div>
    )
  }
}

export default ({ pageContext }) => (
  <Layout>
    <SEO
      title={pageContext.yoast.title}
      description={pageContext.yoast.metadesc}
      ogimg={pageContext.yoast.opengraph_image}
      link={pageContext.link}
    />
    <div className="case-study-cobr-wrapper">
      <div className="container-fluid">
        <div className="row">
          <div
            className="header-container"
            style={{
              backgroundImage: `url(${pageContext.acf.header_image.csOneHedImaLocalFile.childImageSharp.fluid.src})`,
            }}
          >
            <img src={imgQuote} alt="" />
            <h2>{pageContext.acf.header_text}</h2>
          </div>
        </div>
      </div>
      <div className="container detail-wrapper">
        <div className="row">
          <div className="col-md-8">
            <img
              src={
                pageContext.acf.client_logo.csOneCliLogLocalFile.childImageSharp
                  .fluid.src
              }
              className="client-logo"
              width={pageContext.acf.client_logo.media_details.width / 1.5}
              height={pageContext.acf.client_logo.media_details.height / 1.5}
              alt={pageContext.yoast.opengraph_title}
            />
          </div>
          <div className="col-md-4">
            <a
              href="https://www.meritmile.com/uploads/2026/02/merit-mile-city-of-boca-raton-case-study.pdf"
              className="btn downloadBtn"
              target="_blank"
              rel="nofollow noopener noreferrer"
              style={{ marginTop: "4em" }}
            >
              Download the PDF here
            </a>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <div className="bar"></div>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <div
              className="first-paragraph"
              dangerouslySetInnerHTML={{
                __html: pageContext.acf.first_paragraph,
              }}
            />
          </div>
        </div>
      </div>
      <div className="fullWidthLightGrayCTA margin-b">
        <div className="container detail-wrapper">
          <div className="row fifth-paragraph py-0">
            <div className="col-12">
              <blockquote>
                "We are thrilled to partner with a local, Boca Raton-based firm
                like Merit Mile to elevate our Centennial celebration. This
                year-long, community-wide event is a significant milestone that
                demands extensive resources and expertise, and we believe Merit
                Mile is the perfect partner to help us achieve this."
                <cite>
                  - Anne Marie Connolly,
                  <br />
                  &nbsp;&nbsp;Communications and Marketing Director
                </cite>
              </blockquote>
            </div>
          </div>
        </div>
      </div>
      <div className="container detail-wrapper">
        <div className="row">
          <div className="col-12">
            <div
              className="second-paragraph"
              dangerouslySetInnerHTML={{
                __html: pageContext.acf.second_paragraph,
              }}
            />
          </div>
        </div>
      </div>
      <div className="container wider detail-wrapper">
        <div className="row margin-b">
          <div className="col-12">
            <img
              src="https://www.meritmile.com/uploads/2026/02/boca100-turning-100.webp"
              className="quote-image img-fluid"
              alt="Boca100 Challenge"
            />
          </div>
        </div>
      </div>
      <div className="container detail-wrapper">
        <div className="row">
          <div className="col-md-6">
            <div
              className="third-paragraph"
              dangerouslySetInnerHTML={{
                __html: pageContext.acf.third_paragraph,
              }}
            />
          </div>
          <div className="col-md-6">
            <img
              src="https://www.meritmile.com/uploads/2026/02/boca100-challenge.webp"
              className="img-fluid"
              alt="Boca100 Challenge"
              width="500px"
            />
          </div>
        </div>
      </div>
      <div className="container detail-wrapper">
        <div className="row margin-b">
          <div className="col-12 margin-b">
            <h3>Solutions</h3>
            <p>
              Merit Mile approached the Centennial as an integrated marketing
              and events program, anchored by upfront strategy and long-term
              planning, and scaled through programmatic execution over an
              18-month engagement. Early in the process, Merit Mile partnered
              closely with City stakeholders to establish a clear Centennial
              roadmap, defining priorities, governance, workflows, and success
              measures that guided the work throughout the year. This strategic
              foundation ensured alignment across branding, digital experiences,
              communications, partnerships, and content as the Centennial
              evolved.
            </p>
          </div>
        </div>
        <div className="row margin-b">
          <div className="col-md-6">
            <img
              src="https://www.meritmile.com/uploads/2026/02/boca100-solutions.webp"
              className="solution-image img-fluid"
              alt="Boca100 Solutions"
              width="760px"
            />
          </div>
          <div className="col-md-6">
            <h4>Centennial Brand</h4>
            <p>
              A foundational component of this work was the creation of the
              official Centennial brandmark and comprehensive brand guidelines.
              Together, these assets established the visual and tonal foundation
              for the celebration and were designed to scale seamlessly across
              City departments, partners, events, merchandise, digital
              platforms, and municipal services. Merit Mile even developed a
              commemorative{" "}
              <a href="https://boca100.meritmile.com/" target="_blank">
                City of Boca Raton Centennial Branding Center
              </a>{" "}
              for City-approved branding assets including complete logo suites
              and brand guidelines for the Centennial as well as the City’s Fire
              Rescue and Police Departments—an unexpected and memorable way to
              further integrate the Centennial identity into the fabric of Boca
              Raton. This portal became the go-to resource for approved logos,
              guidelines, imagery, and campaign assets—making it easy for
              everyone involved to access the right materials and apply the
              Centennial brand consistently.
            </p>
          </div>
        </div>
        <div className="row margin-b">
          <div className="col-md-6">
            <h4>Centennial Website – Boca100.com</h4>
            <p>
              At the center of everything was{" "}
              <a href="https://www.boca100.com" target="_blank">
                Boca100.com
              </a>
              , the official Centennial destination, designed as a standalone,
              ADA-compliant digital hub for all Centennial activity. Built on
              WordPress and hosted on WP Engine, the site was designed for
              flexibility, performance, and efficient content
              management—allowing City staff and the Merit Mile team to publish
              updates, manage content, and support high-traffic moments
              throughout the Centennial year. Merit Mile owned the end-to-end
              digital experience, including information architecture, UX/UI
              design, copywriting, development, integrations, testing,
              deployment, and ongoing optimization. The site brought together
              event listings, historical timelines, photo and video galleries,
              resident stories, news updates, sponsorship information, and calls
              to action—creating an experience that was intuitive, accessible,
              and welcoming for users of all ages.
            </p>
          </div>
          <div className="col-md-6 text-center">
            <img
              src="https://www.meritmile.com/uploads/2026/02/boca100-solutions-2.webp"
              className="challenge-image img-fluid mx-auto"
              alt="Boca100 Solutions 2"
              width="400px"
            />
          </div>
        </div>
        <div className="row margin-b">
          <div className="col-md-6">
            <img
              src="https://www.meritmile.com/uploads/2026/02/boca100-solutions-3.webp"
              className="img-fluid margin-b"
              alt="Boca100 Solutions 3"
              width="500px"
            />
            <img
              src="https://www.meritmile.com/uploads/2026/02/boca100-merch-design.webp"
              className="img-fluid margin-b"
              alt="Boca100 Solutions 4"
              width="500px"
            />
          </div>
          <div className="col-md-6">
            <h4>Merchandise Design and E-Commerce</h4>
            <p className="margin-b">
              Beyond serving as an informational destination, Boca100.com also
              featured an online storefront, Boca100 Boutique, where people
              could purchase Centennial branded merchandise. Merit Mile designed
              and launched an E-commerce store by WooCommerce, enabling secure
              transactions, order management, drop ship fulfillment, and
              seamless integration with the Centennial website.
            </p>
            <p className="margin-b">
              Close to 50 products were custom designed by Merit Mile, from
              Centennial-branded clothing and Apolis market bags to premium
              products like Peter Millar polos and Yeti Tumblers. There was even
              an iconic Hawaiian shirt custom designed with Boca Raton landmarks
              that proved to be the number 1 top seller. The initiative extended
              beyond traditional merchandise as well, including a creative
              collaboration with O, Miami on Ode to Boca, a civic storytelling
              program that invited residents to express their connection to the
              City through poetry—reinforcing the Centennial’s emphasis on
              place, voice, and community.
            </p>
            <p className="margin-b">
              Merchandise fulfillment was supported through Printify for
              on-demand production and drop-shipping, helping alleviate
              inventory management for the City, while select premium items were
              coordinated for local pickup at City offices—a process Merit Mile
              helped facilitate end to end. The storefront experience supported
              secure checkout, payment apps, order and inventory management, and
              financial/tax reporting.
            </p>
          </div>
        </div>
        <div className="row margin-b">
          <div className="col-md-6">
            <h4>Sponsorship, Donation, and Community Partnership Programs</h4>
            <p className="margin-b">
              A core component of the engagement involved developing structured
              frameworks to support community participation. Merit Mile created
              comprehensive Sponsorship, Donation, and Community Partnership
              programs, each built around clearly defined tiering structures,
              participation levels, and value exchanges. Each tier was supported
              by a custom-designed badge, giving sponsors, donors, and partners
              a clear visual identity that could be used consistently across
              digital and physical touchpoints.
            </p>
            <p className="margin-b">
              To support outreach and activation, Merit Mile developed a full
              marketing kit—including social media graphics, flyers, brochures,
              and digital assets—used by the City’s team when engaging
              prospective sponsors and partners. Additional promotional
              materials were also created for the City, partners, and sponsors
              to use in their own communications, extending the reach of the
              Centennial while maintaining a cohesive visual system. These
              programs and tools were published and managed through the
              Centennial website, providing the City with scalable, easy-to-use
              models for engagement.
            </p>
            <p>
              Merit Mile also played a central role in identifying and securing
              key local partnerships, including collaboration with the Boca
              Raton Historical Society to elevate historical storytelling and
              securing a partnership with Prosperity Brewers that resulted in
              the creation of a specialty beer brew, “1925 Centenni-Ale,” a
              signature Centennial product honoring the City's founding year
              that is still available in community restaurants and retail
              locations.
            </p>
          </div>
          <div className="col-md-6 text-center">
            <img
              src="https://www.meritmile.com/uploads/2026/02/boca100-solutions-4.webp"
              className="challenge-image img-fluid mx-auto margin-b"
              alt="Boca100 Solutions 4"
              width="500px"
            />
          </div>
        </div>
        <div className="row margin-b">
          <div className="col-12 text-center">
            <img
              src="https://www.meritmile.com/uploads/2026/02/boca100-solutions-5.webp"
              className="img-fluid mx-auto margin-b"
              alt="Boca100 Solutions 5"
            />
          </div>
        </div>
        <div className="row margin-b">
          <div className="col-md-6">
            <img
              src="https://www.meritmile.com/uploads/2026/02/boca100-solutions-6.webp"
              className="solution-image img-fluid margin-b"
              alt="Boca100 Solutions 6"
              width="660px"
            />
          </div>
          <div className="col-md-6">
            <h4>Communications, Advertising, and Ongoing Execution</h4>
            <p className="margin-b">
              Throughout the Centennial, Merit Mile maintained a steady cadence
              of strategic and tactical support. This included ongoing creative
              direction, copywriting, website updates, social media planning and
              content development, advertising design, media coordination, and
              project management—supported by regular leadership touchpoints
              with City stakeholders. A weekly meeting and reporting cadence as
              well as an ongoing dynamic marketing calendar kept stakeholders
              informed and teams aligned.
            </p>
            <p className="margin-b">
              Merit Mile also led cross-functional coordination across creative
              execution, digital and social channels, media placements, and
              third-party partners, ensuring consistent messaging and seamless
              delivery across all platforms.
            </p>
          </div>
        </div>
        <div className="row margin-b">
          <div className="col-md-6">
            <h4>Video and Photography</h4>
            <p className="margin-b">
              To preserve the memories for future generations and extend the
              reach of the Centennial, Merit Mile provided on-site photography
              and{" "}
              <a
                href="https://www.youtube.com/playlist?list=PL6h6YN8PgH5m0vEjcoVtIlWqzU1Bs2-8b"
                target="_blank"
              >
                video coverage
              </a>{" "}
              across signature Centennial events and initiatives. Five turnkey
              videos were produced end to end—spanning concept development,
              scripting, filming, and post-production—supported by an extensive
              visual library.
            </p>
            <p className="margin-b">
              These assets fueled digital campaigns, social media, TV broadcast
              placements, City communications, and broader storytelling
              initiatives, while also serving as a lasting archival record of
              the Centennial year.
            </p>
          </div>
          <div className="col-md-6">
            <img
              src="https://www.meritmile.com/uploads/2026/02/boca100-solutions-7.webp"
              className="challenge-image img-fluid margin-b"
              alt="Boca100 Solutions 7"
              width="760px"
            />
          </div>
        </div>
      </div>
      <div className="container wider detail-wrapper">
        <div className="row">
          <div className="col-md-4">
            <VideoLauncher />
          </div>
          <div className="col-md-4">
            <VideoLauncherTwo />
          </div>
          <div className="col-md-4">
            <VideoLauncherThree />
          </div>
        </div>
      </div>
      <div className="container detail-wrapper margin-b">
        <div className="row margin-b">
          <div className="col-12 margin-b">
            <h3>Results</h3>
            <p className="margin-b">
              Merit Mile's sustained strategic ownership and hands-on execution
              resulted in a Centennial program that delivered measurable impact
              across digital engagement, commerce, partnerships, communications,
              and community storytelling. Among commerce, donations, and a
              variety of Centennial sponsorship and partner fund raising
              initiatives, revenues generated for the 18-month community
              initiative offset marketing expenses to nearly break-even levels.
            </p>
            <p>&nbsp;</p>
            <h4>Digital Engagement, Website, and E-Commerce Performance</h4>
            <p>
              The Centennial website quickly became the central destination for
              the year-long celebration, attracting 40,000+ site visitors in
              2025 alone—a figure that, when viewed against Boca Raton’s
              population of roughly 102,000 residents, underscores the scale of
              community interest and engagement. Residents, visitors, and
              businesses relied on Boca100.com to discover events, explore the
              City's history, engage with Centennial content, and participate
              through merchandise, sponsorships, and donations—reinforcing the
              site's role as the connective hub for the initiative. Centennial
              merchandise also proved to be a strong engagement driver and
              meaningful revenue stream. Seasonal releases, signature event
              promotions, and limited-edition holiday apparel helped sustain
              momentum while extending the Centennial brand into everyday
              community life.
            </p>
          </div>
        </div>
        <div className="row margin-b">
          <div className="col-md-6 margin-b">
            <h4>Sponsorships and Partnerships</h4>
            <p>
              Merit Mile helped the City activate and manage fourteen local
              sponsors and partners, supported by clearly tiered participation
              levels, custom partner badges, and turnkey outreach and
              promotional materials. Through a combination of sponsorships,
              partnerships, merchandise commerce, and donations, the Centennial
              initiative recouped approximately 90% of the City's marketing
              investment, significantly offsetting program costs while
              strengthening private-sector and community involvement.
            </p>
          </div>
          <div className="col-md-6 margin-b text-center">
            <img
              src="https://www.meritmile.com/uploads/2026/02/boca100-results.webp"
              className="results-image img-fluid mx-auto"
              alt="Sponsors of Boca100"
              width="400px"
            />
          </div>
        </div>
        <div className="row margin-b">
          <div className="col-md-6 margin-b">
            <h4>Video, Photography, and Event Coverage</h4>
            <p>
              Merit Mile provided on-site coverage across signature Centennial
              events, capturing hours of video footage and thousands of
              photographs to support real-time promotion, post-event
              storytelling, and long-term archival use. Major events documented
              included Boca Street Fest, the Centennial Celebration Weekend
              Concert (featuring Weezer and Fountains of Wayne), the Centennial
              Drone Show at the Boca Raton Innovation Campus, the Holiday Street
              Parade, the Wildflower Park Art Unveiling, and additional City-led
              activations.
            </p>
            <p>
              Video production efforts included a{" "}
              <a href="https://youtu.be/YV_sMfdArAM" target="_blank">
                Centennial Sizzle Reel
              </a>{" "}
              to kick off the year, a{" "}
              <a
                href="https://youtube.com/shorts/Ti825DDSOYs?feature=share"
                target="_blank"
              >
                Website Launch teaser
              </a>
              , event-specific promotional assets—including two unique broadcast{" "}
              <a
                href="https://www.youtube.com/playlist?list=PL6h6YN8PgH5nqxFIQWqrtVG7eLJIpoFw3"
                target="_blank"
              >
                television ads
              </a>{" "}
              for Boca Street Fest—
              <a href="https://youtu.be/bUcZIkdJDHU" target="_blank">
                A Century of Community resident storytelling video
              </a>
              , and a{" "}
              <a href="https://youtu.be/jiXygt8DkmQ" target="_blank">
                Centennial Recap video
              </a>{" "}
              to close the year, collectively creating a complete visual
              narrative from launch through legacy.
            </p>
          </div>
          <div className="col-md-6 margin-b">
            <h4>Communications, Advertising & Media Presence</h4>
            <p>
              Throughout the Centennial year, Merit Mile produced dozens of
              communications assets and social media posts, ensuring consistent
              visibility across City-owned and partner channels. Monthly print
              advertisements were designed and placed in prominent local and
              regional publications including Boca Magazine, Sun Sentinel, Boca
              Observer, and other South Florida outlets. In parallel, digital
              and video advertising supported major events and milestones,
              extending reach and driving attendance.
            </p>
            <img
              src="https://www.meritmile.com/uploads/2026/02/cheers-to-100-years.webp"
              className="results-image img-fluid"
              alt="Cheers to 100 Years"
              width="616px"
            />
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <h4>Lasting Impact</h4>
            <p>
              Together, these results reflect a Centennial program that went
              beyond celebration. The initiative strengthened community pride,
              expanded resident and visitor participation, engaged local
              businesses, and established a modern, repeatable framework for
              digital engagement, sponsorship activation, content creation, and
              brand stewardship.
            </p>
            <p>
              The Centennial didn't just celebrate Boca Raton's past—it brought
              the City's story to life and set a new standard for how Boca Raton
              engages, celebrates, and connects with its community.
            </p>
          </div>
        </div>
      </div>
      <div className="fullWidthLightGrayCTA">
        <div className="container detail-wrapper">
          <div className="row fifth-paragraph py-0">
            <div className="col-12">
              <blockquote>
                "We're proud to recognize Merit Mile for their outstanding work
                as the official marketing consultants for Boca Raton’s
                Centennial celebration! Over the past year, they’ve helped bring
                #Boca100 to life, beginning with the creation of our vibrant
                Centennial brandmark that captures the spirit, history, and
                energy of our community. Thank you, Merit Mile, for your
                creativity, collaboration, and commitment to celebrating 100
                years of Boca Raton!"
                <cite>- City of Boca Raton</cite>
              </blockquote>
            </div>
          </div>
        </div>
      </div>
      <div className="container wider detail-wrapper">
        <div className="row margin-b">
          <div className="col-12 my-5">
            <img
              src="https://www.meritmile.com/uploads/2026/02/boca100-results-3.webp"
              className="quote-image img-fluid my-4"
              alt="Boca100 Outcome"
            />
          </div>
        </div>
      </div>
      <div className="container detail-wrapper">
        <div className="row margin-b">
          <div className="col-12">
            <h3>Outcome</h3>
            <p>
              The success of the Centennial program established Merit Mile as a
              trusted strategic partner beyond the scope of a single initiative.
              As the year progressed, City leadership continued to engage Merit
              Mile on additional, forward-looking projects—reflecting a strong
              working rhythm and confidence in the team's ability to handle
              complex initiatives. This expanded collaboration included
              exploratory design work for a new City of Boca Raton flag at the
              mayor’s request, concept development for redesigned City entryway
              signage, and comprehensive brandmark exploration for Downtown
              Boca. Merit Mile also evolved the Centennial identity into two
              refreshed City of Boca Raton logo concepts intended to support the
              City's visual identity beyond the Centennial year—extending the
              value of the original system into the future.
            </p>
          </div>
        </div>
        <div className="row margin-b">
          <div className="col-md-6">
            <p>
              In parallel, Merit Mile partnered closely with the City of Boca
              Raton's Office of Economic Development, providing both creative
              and public relations support. Merit Mile led a comprehensive PR
              program encompassing planning, messaging and positioning, press
              materials, media relations, and thought leadership strategy,
              resulting in 46 earned media placements across a range of
              high-profile publications such as The South Florida Business
              Journal, The Washington Post, and FOX 2 Detroit. On the
              advertising side, Merit Mile transformed the Office of Economic
              Development’s Boyd Report—an independent economic analysis
              highlighting the cost, talent, and quality-of-life advantages of
              doing business in Boca Raton—into a refined, City-branded
              marketing asset. The work enhanced clarity, visual storytelling,
              charts, and overall flow while preserving the integrity of the
              research, enabling the City to more effectively communicate Boca
              Raton’s value proposition to prospective businesses and
              site-selection stakeholders.
            </p>
          </div>
          <div className="col-md-6">
            <img
              src="https://www.meritmile.com/uploads/2026/02/boca100-outcome.webp"
              className="quote-image img-fluid"
              alt="Sample of Partner Branded Deliverable 2"
            />
          </div>
        </div>
      </div>
      <div className="fullWidthLightGrayCTA">
        <div className="container detail-wrapper">
          <div className="row fifth-paragraph py-0">
            <div className="col-12">
              <blockquote>
                "Thank you for being amazing partners this last year and a half.
                It has been such a pleasure working with you all and looking
                forward to continuing to do so on other projects."
                <cite>
                  - Amy DiNorscio,
                  <br />
                  &nbsp;&nbsp;Amphiteater and Community Events Manager
                </cite>
              </blockquote>
            </div>
          </div>
        </div>
      </div>
      <div className="fullWidthImageWrapper text-center">
        <img
          src="https://www.meritmile.com/uploads/2026/02/boca100-thank-you.webp"
          alt="Thank You City of Boca Raton"
          className="img-fluid"
        />
      </div>
      <div className="container detail-wrapper">
        <div className="row fifth-paragraph margin-b">
          <div className="col-12">
            <div className="">
              <h3>
                <b style={{ fontWeight: "400", fontStyle: "italic" }}>
                  Services
                </b>
              </h3>
              <ul>
                <li>
                  Strategic planning, execution, and management of an 18-month
                  City-Centennial program
                </li>
                <li>
                  Full brand strategy, visual identity framework, brand
                  guidelines, and brand portal
                </li>
                <li>
                  Boca100.com centennial website including strategy, IA,
                  copywriting, UX/UI, development, integrations, ADA compliance,
                  testing, and ongoing optimizations
                </li>
                <li>
                  E-commerce storefront and donor platform design and build
                </li>
                <li>
                  Development of a partner, sponsor, and donor programs
                  including financial models, program tiers, marketing kits, and
                  promotion
                </li>
                <li>
                  Video production including concepting, storyboarding, scripts,
                  onsite shoots, pre-and-post-production services
                </li>
                <li>Event filming, photography, and onsite reporting</li>
                <li>
                  Creative development and copywriting of all Centennial
                  marketing assets including digital, print, social, and
                  communications
                </li>
                <li>
                  Intra-agency leadership functions across public relations,
                  display/media advertising, and third-party vendors nationwide
                </li>
                <li>
                  Liaison with a variety of City partner constituencies to steer
                  Centennial awareness and demand marketing activities,
                  including partner onboarding
                </li>
                <li>
                  Ongoing website management, updates, support & optimization
                </li>
                <li>
                  3rd party vendor management, contracting, and pass-through
                </li>
                <li>
                  Project management, reporting, dashboards against the master
                  Centennial plan
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="fullWidthLightGrayCTA">
        <div className="container detail-wrapper">
          <div className="row fifth-paragraph margin-b">
            <div className="col-12">
              <div className="">
                <h3>
                  <b style={{ fontWeight: "400", fontStyle: "italic" }}>
                    Deliverables
                  </b>
                </h3>
                <ul>
                  <li>
                    Centennial brandmark, visual identity system, and brand
                    guidelines
                  </li>
                  <li>Centennial messaging and positioning frameworks</li>
                  <li>
                    Centralized Centennial brand and media portal (logos,
                    guidelines, imagery, campaign assets)
                  </li>
                  <li>Boca100.com Centennial website</li>
                  <li>Boca100 Boutique e-commerce storefront</li>
                  <li>
                    Sponsor, partner, and donor program packages (tiers, visual
                    badges, marketing kits)
                  </li>
                  <li>
                    Event-specific creative and on-site materials (signage,
                    programs, promotional assets)
                  </li>
                  <li>
                    Broadcast, digital, and print advertising assets for key
                    Centennial events
                  </li>
                  <li>
                    Centennial photo and video library (produced five videos and
                    event photography)
                  </li>
                  <li>Ongoing social media content</li>
                  <li>Centennial email and communications assets</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="fullWidthGrayCTA">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h5>
                Learn more about how Merit Mile can support your vertical
                content marketing, lead generation, and sales goals by
                contacting{" "}
                <a href="mailto:Hello@MeritMile.com?subject=Citrix%20%20Google%20ChromeOS20DaaS%20Case%20Study%20Inquiry">
                  <b style={{ color: "black" }}>hello@meritmile.com.</b>
                </a>
              </h5>
            </div>
          </div>
        </div>
      </div>
      <div className="fullWidthImageWrapper text-center">
        <img
          src="https://www.meritmile.com/uploads/2021/09/mm-divider.jpg"
          alt="Merit Mile Icon Divider"
          className="img-fluid"
        />
      </div>
      <div className="about-wrapper">
        <div className="container">
          <div className="row">
            <div className="col">
              <h2>About Merit Mile</h2>
            </div>
          </div>
          <div className="row margin-b">
            <div className="col-md-6">
              <p>
                Established in 2007 in Boca Raton, FL, Merit Mile is a marketing
                services provider focused on helping companies and corporate
                marketing departments build brands, drive sales revenue, and
                garner publicity in their respective industries. Our unique
                differentiator at Merit Mile is our ability to 100% own the
                message, the publicity, and the demand generation aspects of the
                corporate marketing function. Clients hire us and rehire us for
                our ability to refine their messaging/value proposition, develop
                top and mid-funnel leads, and get the type of editorial
                publicity that differentiates them from their competitors. From
                branding to PR to demand generation, Merit Mile is the
                high-octane fuel that invigorates corporate growth engines. To
                learn more, please email us at Hello@MeritMile.com, call us at
                1-561-362-888, or visit us at www.MeritMile.com.{" "}
              </p>
            </div>
            <div className="col-md-6">
              <img
                className="img-fluid"
                src="https://www.meritmile.com/uploads/2021/06/mm-headquarter.webp"
                alt="Merit Mile Headquarter in Boca Raton, FL"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="container quote-wrapper">
        <div className="row">
          <div className="col-12">
            <p>
              For more insights and to connect
              <br />
              with Merit Mile{" "}
              <a href="mailto:Hello@MeritMile.com?subject=City%20of%20Boca%20Raton%20Case%20Study%20Inquiry">
                <b style={{ color: "black" }}>email us here</b>
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </Layout>
)
